export function microtype(text, locale) {
    if(!text) return text;
    if (locale === 'de') {
        return _microtype(text);
    } else if (locale === 'en') {
        return _microtype(text, '“”', '‘’');
    }
    return text;
}

/**
 * Replaces double and single quotes with german typographic quotes.
 *
 * @param text string
 * @param doubleQuotes string - default: "„“"
 * @param singleQuotes string - default: "‚‘"
 * @returns string
 */
function _microtype(text, doubleQuotes = "„“", singleQuotes = "‚‘") {
    if(!text) return text;
    let t = text;
    t = t.replace(/(\s|^|-|\(|\u200b)(<[^>]*>)?"(\S+)/g, `$1$2${doubleQuotes[0]}$3`); // leading double quotes
    t = t.replace(/(\s|^|-|\(|\u200b)(<[^>]*>)?'(\S+)/g, `$1$2${singleQuotes[0]}$3`); // leading single quotes
    t = t.replace(/(\S+)'([.,:;!?"]*)(<[^>]*>)?(\s|$|-|\))/g, `$1${singleQuotes[1]}$2$3$4`); // trailing double quotes
    t = t.replace(/(\S+)"([.,:;!?‘]*)(<[^>]*>)?(\s|$|-|\))/g, `$1${doubleQuotes[1]}$2$3$4`); // trailing single quotes
    t = t.replace(/(\s)-([,;:\s]+)/g, '$1–$2'); // dash
    return t;
}
